import { COACHES } from '../../fixtures/coaches';
import { renderCoachName } from '../../lib/coachName';
import { MarketingPhoneStatusBar } from './MarketingPhoneFrame';
import styles from './CoachRosterPreview.module.css';

/**
 * 5-coach roster rendered inside a phone frame. Used in the landing
 * Plan Showcase section. Marketing-only — no interactive elements.
 *
 * IMPORTANT: imports COACHES from the canonical fixture
 * (training/gear/race/recovery/mental). The original mockup
 * hardcoded a fictional Strength Coach (`ZAIo`); this preview
 * intentionally does NOT reproduce that error. See plan Decisions
 * & Handoff for the reconciliation.
 */
export function CoachRosterPreview() {
  return (
    <>
      <MarketingPhoneStatusBar />
      <div className={styles.surface}>
        <div className={styles.header}>
          <span className={styles.kicker}>Your coaching team</span>
          <span className={styles.title}>
            Five coaches.{' '}
            <span className={styles.titleEm}>One system.</span>
          </span>
        </div>

        <div className={styles.list}>
          {COACHES.map((c) => (
            <div key={c.id} className={styles.row}>
              <span
                className={styles.avatar}
                style={{ background: c.token }}
              >
                {c.initial}
              </span>
              <div className={styles.body}>
                <span className={styles.name}>
                  {/* --today on dark — coach hex contrast against the
                      ink-900 phone bg is poor for several coaches
                      (Vaira blue, Kairu plum). Identity is conveyed by
                      the avatar tile. */}
                  {renderCoachName(c.name, 'var(--today)')}
                </span>
                <span className={styles.role}>{c.role}</span>
              </div>
              <svg
                className={styles.chevron}
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                aria-hidden
              >
                <path
                  d="M5 3l4 4-4 4"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
